import { Component, Input } from "@angular/core";
import { BrandCampaign } from "../../../../shared/models/brandCampaign";
import { PostLogStatus } from "../../../../shared/enums/campaignPost.enums";
import { BrandPostLog } from "../../../../shared/types/postLog.types";

@Component({
  selector: "app-brand-campaign-posts-list",
  templateUrl: "./brand-campaign-posts-list.component.html",
  styleUrl: "./brand-campaign-posts-list.component.scss",
})
export class BrandCampaignPostsListComponent {
  @Input({ required: true }) public readonly campaign!: BrandCampaign;
  @Input({ required: true }) public readonly type!: PostLogStatus;
  @Input({ required: true }) public readonly posts!: BrandPostLog[];
}
